export default new Vue({
  beforeCreate() {
    if (process.env.NODE_ENV == 'production') {
      window.l = () => { }
      window.e = () => { }
    } else {
      window.l = console.log.bind(console)
      window.e = console.error.bind(console)
    }
  },

  data: () => ({
    db: {}, // Realtime db
    db_refs: {},
    fs: null, // Firestore
    data: {},
    is_drawer_visible: true,
    is_loading: false,
    is_inter_ad_loading: false,
    is_searching: false,
    is_refreshing: false,
    is_shuffle: false, // Used in video page and video player
    is_firebase_initialized: false,

    env: null,
    session_token: null,
    session_token_expire_time_unix: null,
    user: null,
    user_setting: null,
    user_search_option: null,
    playlists: null,
    jwt: null,
    jwt_expire_at: null,
    spaces_access_key: null,
    spaces_secret_key: null,
    spaces_endpoint: null,

    general_confirmation_dialog_defaults: {
      is_visible: true,
      is_persistent: false,
      is_mini_close_button_visible: true,
      is_cancel_button_visible: true,
      title: "",
      body: "",
      confirm_button_text: "Confirm",
      confirmation_callback: null,
    },

    general_confirmation_dialog: {
      is_visible: false,
      is_persistent: false,
      is_mini_close_button_visible: true,
      is_cancel_button_visible: true,
      title: "",
      body: "",
      confirm_button_text: "Confirm",
      confirmation_callback: null,
    },

    s3: null,
    algolia: null,
    tags: null,
    width: 0,
    height: 0,
    version: 0,
    ip: null,
    geo: null,
    fb: null, // firebase realtime db
    servers: [],
  }),

  created() {
  },

  methods: {
    sessionToken() {
      let session_token = Cookies.get("htv3session")
      if (typeof session_token == "undefined" || session_token == "undefined") { // in case it's a string w/ the word undefined
        session_token = ""
      }
      if (!session_token && S.session_token_expire_time_unix) {
        let session_token_expire_time_js = new Date(S.session_token_expire_time_unix * 1000)

        if (session_token_expire_time_js >= new Date()) {
          session_token = S.session_token
        }
      }

      return session_token
    },

    headers() {
      return {
        headers: {
          'X-Directive': 'api',
          'X-Session-Token': this.sessionToken(),
        }
      }
    },

    ajax(method, url, payload = {}, callback_event_name = null, error_callback_event_name = null) {
      if (S.is_loading) {
        return null
      }

      S.is_loading = true

      let req = null
      if (method == 'get' || method == 'delete') {
        req = axios[method](`${api_base_url}${url}`, S.headers())
      } else {
        req = axios[method](`${api_base_url}${url}`, payload, S.headers())
      }

      req.then(data => {
        if (callback_event_name) {
          // l('success callback event, emitting:', callback_event_name)
          S.$emit(callback_event_name, data)
        }

        S.is_loading = false
      }).catch(err => {
        l('err:')
        l(err)
        if (error_callback_event_name) {
          // l('error callback event, emitting:', error_callback_event_name)
          S.$emit(error_callback_event_name, err)
        }

        S.is_loading = false
      })
    },

    get(url, callback_event_name = null, error_callback_event_name = null) {
      this.ajax('get', url, {}, callback_event_name, error_callback_event_name)
    },

    post(url, payload = {}, callback_event_name = null, error_callback_event_name = null) {
      this.ajax('post', url, payload, callback_event_name, error_callback_event_name)
    },

    put(url, payload = {}, callback_event_name = null, error_callback_event_name = null) {
      this.ajax('put', url, payload, callback_event_name, error_callback_event_name)
    },

    timeAgo(now, past) {
      // now and past should be JS Date() objects. past should be less
      // than now.
      if (!now || !past)
        return ''

      let diff_ms = now - past

      /*
      one_minute_in_ms: 60000,
      one_hour_in_ms: 3600000,
      one_day_in_ms: 86400000,
      one_week_in_ms: 604800000,
      one_month_in_ms: 2592000000,
      */

      if (diff_ms <= 60000) {
        return `a few seconds ago`
      } else if (diff_ms <= 3600000) {
        let minutes = parseInt(diff_ms / 60000)
        if (minutes < 2) {
          return `a minute ago`
        } else {
          return `${minutes} minutes ago`
        }
      } else if (diff_ms <= 86400000) {
        let hours = parseInt(diff_ms / 3600000)
        if (hours < 2) {
          return `an hour ago`
        } else {
          return `${hours} hours ago`
        }
      } else if (diff_ms <= 604800000) {
        let days = parseInt(diff_ms / 86400000)
        if (days < 2) {
          return `yesterday`
        } else {
          return `${days} days ago`
        }
      } else if (diff_ms <= 2592000000) {
        let weeks = parseInt(diff_ms / 604800000)
        if (weeks < 2) {
          return `last week`
        } else {
          return `${weeks} weeks ago`
        }
      } else {
        let months = parseInt(diff_ms / 2592000000)
        let plurality = 'months'
        if (months < 2) {
          plurality = 'month'
        }
        return `${months} ${plurality} ago`
      }
    },

    isValidEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },

    confirm(params) {
      S.general_confirmation_dialog = {
        ...S.general_confirmation_dialog_defaults,
        ...params,
        is_visible: true
      }
    },

    alert(params) {
      if (typeof params == "string") {
        S.general_confirmation_dialog = {
          ...S.general_confirmation_dialog_defaults,
          is_cancel_button_visible: false,
          title: "Notification",
          body: params,
          confirm_button_text: "OK",
          confirmation_callback: () => {
            S.general_confirmation_dialog.is_visible = false
          },
        }
      } else {
        S.general_confirmation_dialog = {
          ...S.general_confirmation_dialog_defaults,
          ...params,
          is_visible: true
        }
      }
    },

    guid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    },

    dateHuman(unix_seconds) {
      let date = new Date(parseInt(unix_seconds) * 1000)
      return `${date.getFullYear()}-${(date.getUTCMonth() + 1).toString().padStart(2, '0')}-${date.getUTCDate().toString().padStart(2, '0')}`
    },

  },// methods

})
